var parent = require('../../es/number/parse-float');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/number/parse-float.js
// module id = 1284
// module chunks = 25